<template>
<div class="emailEdit_page">
    <div class="header">
        <el-input
        placeholder="请输入主题"
        v-model="subject"
        maxlength="150"
        show-word-limit
        clearable
        class="subject_input">
        </el-input>
        <el-button type="primary" @click="sendGroupEmail">发送</el-button>
    </div>
    <div id="edit" class="wang_edit"></div>
</div>
</template>
<script>
import E from 'wangeditor'
import {trim} from '../assets/js/index'
export default {
    data(){
        return {
            editor: null,
            subject: '',
            content: '',
        }
    },
    mounted(){
        const editor = new E('#edit')
        this.editor = editor
        editor.config.height = 500
        editor.config.placeholder = '请输入群发邮件内容'
        editor.config.zIndex = 5
        editor.config.excludeMenus = [
            'emoticon',
            'video',
            'image',
            'code'
        ]
        editor.create()
    },
    methods: {
        sendGroupEmail(){
            this.content = this.editor.txt.html()
            if (!trim(this.subject)) {
                this.$message.error('主题不能为空')
                return false
            } else if (this.subject.length > 150) {
                this.$message.error('主题长度不能超过150个字符')
                return false
            } else if (!trim(this.content)) {
                this.$message.error('邮件内容不能为空')
                return false
            }
            this.$confirm('确认发送该内容吗？')
            .then(() => {
                this.$axios.post('/group_email/',{
                    subject: trim(this.subject),
                    content: this.content
                })
                .then(res => {
                    if (res.status === 1) {
                        this.$message.success('发送成功')
                        this.$router.push('/email')
                    }
                })
            })
            .catch(res => {
                this.$message.info('已取消')
                console.log(res)
            })
        }
    }
}
</script>
<style lang="less" scoped>
.emailEdit_page{
    padding: 20px;
    .header{
        display: flex;
        .subject_input{
            width: 50%;
            margin-right: 20px;
        }
    }
    .wang_edit{
        margin-top: 20px;
    }
}
</style>